import http from '@root/utils/axios/admin';

let state = {
    GpusList: [],
    Gpu: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGpusList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/gpus', { params: filter }).then((response) => {
                commit('setGpusList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGpu({ commit }, id) {
        return http.delete('user/gpus/' + id);
    },

    fetchGpu({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/gpus/' + id).then((response) => {
                commit('setGpu', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGpu({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/gpus', data).then((response) => {
                commit('setGpu', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGpuError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGpu({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/gpus/' + data.id, data).then((response) => {
                commit('setGpu', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGpuError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGpusList(state, data) {
        state.GpusList = data;
    },
    setGpu(state, data) {
        state.Gpu.data = data;
    },
    setGpuError(state, error) {

        state.Gpu.error = error.errors;
    },
    cleanGpuError(state, error) {
        state.Gpu.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}